import { store } from '../../../../app/store'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentNonBank,
  typeComponentSecurity,
} from '../../../companyAnalysis/financial/financialAnalysis/constant'
import {
  resetFullStore as resetFullStoreFinancialAnalysis,
  selectSliceFinancialAnalysis,
} from '../../../companyAnalysis/financial/financialAnalysis/store/slice'
import { getDefaultTemplateForLayoutThunk } from '../../../companyAnalysis/financial/financialAnalysis/store/thunk'
import { COMPANY_TYPES } from '../../../utils/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_ITEM_SETTING,
  WIDTH_PDF_LANSCAPE_WITHOUT_PADDING,
  WIDTH_PDF_PORTRAIT_WITHOUT_PADDING,
} from '../constant'
import {
  getDefaultCompanyAnalysis,
  getPanelCompanyAnalysis,
  getPanelListCompanyAnalysis,
} from './companyAnalysis'
import { PANELS } from './companyAnalysis/industryOverview'

import {
  getDefaultPortfolioInsight,
  getPanelListPortfolioInsight,
  getPanelPortfolioInsight,
} from './portfolioInsight'

export const getPanelDetail = ({ mainScreen, ...param }) => {
  switch (mainScreen) {
    case MAIN_SCREEN.COMPANY_ANALYSIS:
      return getPanelCompanyAnalysis(param)
    case MAIN_SCREEN.PORTFOLIO_INSIGHT:
      return getPanelPortfolioInsight(param)
    default:
      return {}
  }
}

export const getPdfHeightImage = (
  width = 0,
  height = 0,
  isLandscape = false,
) => {
  return (
    height *
    ((isLandscape
      ? WIDTH_PDF_LANSCAPE_WITHOUT_PADDING
      : WIDTH_PDF_PORTRAIT_WITHOUT_PADDING) /
      width)
  )
}

export const cloneNodeIncludeContent = (el) => {
  const newEl = el.cloneNode()
  newEl.innerHTML = el.innerHTML
  return newEl
}

export const getPanelList = (mainScreen, companyType) => {
  const commonPanel = [
    {
      label: 'dynamicReport.CHAPER_HEADER',
      type: TYPE_ITEM_SETTING.CHAPTER_HEADER,
    },
  ]
  switch (mainScreen) {
    case MAIN_SCREEN.COMPANY_ANALYSIS:
      return [...commonPanel, ...getPanelListCompanyAnalysis(companyType)]
    case MAIN_SCREEN.PORTFOLIO_INSIGHT:
      return [...commonPanel, ...getPanelListPortfolioInsight()]
    default:
      return {}
  }
}

export const handleBeforeGetDefaultCompanyAnalysis = async ({
  dispatch,
  companyType,
}) => {
  // financial analysis
  const stateFinancialAnalysis = selectSliceFinancialAnalysis(store.getState())
  const keyPanel = Object.values(
    companyType === COMPANY_TYPES.CORPORATE
      ? typeComponentCorporate
      : companyType === COMPANY_TYPES.BANK
      ? typeComponentBank
      : companyType === COMPANY_TYPES.NON_BANK
      ? typeComponentNonBank
      : typeComponentSecurity,
  )
  if (
    !stateFinancialAnalysis.panelId?.length ||
    stateFinancialAnalysis.panelId.some(
      (id) => !keyPanel.includes(stateFinancialAnalysis.panelById[id]?.key),
    )
  ) {
    await dispatch(
      getDefaultTemplateForLayoutThunk({ TemplateType: companyType }),
    )
  }
}

export const handleAfterGetDefaultCompanyAnalysis = async ({ dispatch }) => {
  // financial analysis
  dispatch(resetFullStoreFinancialAnalysis())
}

export const getDefaultDynamicReport = (mainScreen, { companyType }) => {
  switch (mainScreen) {
    case MAIN_SCREEN.COMPANY_ANALYSIS:
      return getDefaultCompanyAnalysis(companyType)
    case MAIN_SCREEN.PORTFOLIO_INSIGHT:
      return getDefaultPortfolioInsight()
    default:
      return []
  }
}

export const getIdToc = (page, index) => `page${page}_index${index}`

export const isFs = (screen) =>
  screen === SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_STATEMENT

export const isMacroeconomics = (panel) =>
  panel === PANELS.MACROECONOMICS_FDI ||
  panel === PANELS.MACROECONOMICS_GDP ||
  panel === PANELS.MACROECONOMICS_IMPORT_EXPORT
